import { StyleSheet, Text, View, Image } from "react-native";
import React, { useState, useContext, useEffect } from "react";
import axios from "axios";

import UserContext from "../store/user-data-context";
import { Ionicons, FontAwesome5 } from "@expo/vector-icons";

import Button from "../components/Button";
import ComfirmLayout from "../components/ComfirmLayout";

const Lottery = ({ route }) => {
  const userCtx = useContext(UserContext);

  const [gotGashapon, setGotGashapon] = useState(false);
  const [showComfirmLayout, setShowComfirmLayout] = useState(false);
  const [comfirmResult, setComfirmResult] = useState(false);
  const [isDailyComplete, setIsDailyComplete] = useState(true);

  const [pickUpWord, setPickUpWord] = useState("");
  const [lotteryComplete, setLotteryComplete] = useState(false);

  const user = route.params.userName;

  useEffect(() => {
    const selectWordArray = []; //本地儲存
    const timeArray = []; //本地儲存
    userCtx.setUserName(user); //context儲存
    async function fetchUserData() {
      const userData = await axios
        .get(
          `https://react-getting-started-d269e-default-rtdb.asia-southeast1.firebasedatabase.app/fb2022festival/${user}.json`
        )
        .then((res) => {
          if (res.data !== null) {
            for (const key in res.data /*資料是存在回傳的一大疊資料中的data key中。*/) {
              const word = res.data[key].word;
              const time = res.data[key].date;
              selectWordArray.push(word);
              timeArray.push(new Date(time).getTime());
            }
            userCtx.setSelectWordList(selectWordArray); //context儲存
            if (new Date().getTime() - Math.max(...timeArray) > 86400000) {
              //set 1min priod timeout.
              setIsDailyComplete(false);
            }
          } else if (res.data === null) {
            setIsDailyComplete(false);
          }
        });
      if (
        userCtx.selectWordList.includes("尊") &&
        userCtx.selectWordList.includes("師") &&
        userCtx.selectWordList.includes("慶") &&
        userCtx.selectWordList.includes("典")
      ) {
        setLotteryComplete(true);
      }
    }
    if (selectWordArray.length === 0) {
      fetchUserData();
    }
  }, []);

  const lotteryPickUpWordFunction = async () => {
    const existWordArray = await axios
      .get(
        `https://react-getting-started-d269e-default-rtdb.asia-southeast1.firebasedatabase.app/fb2022festival/${user}.json`
      )
      .then((res) => {
        return res.data;
      });
    const wordArray = ["尊", "師", "慶", "典"];
    let index = Math.floor(Math.random() * 4);
    setPickUpWord(wordArray[index]);
    console.log(pickUpWord);

    if (existWordArray === null) {
      console.log(1);
      await axios
        .post(
          `https://react-getting-started-d269e-default-rtdb.asia-southeast1.firebasedatabase.app/fb2022festival/${user}.json`,
          { word: wordArray[index], date: new Date() }
        )
        .then((res) => {
          return res.data;
        });
      userCtx.setSelectWordList((prev) => [...prev, wordArray[index]]);
    } else {
      console.log(2);
      await axios
        .post(
          `https://react-getting-started-d269e-default-rtdb.asia-southeast1.firebasedatabase.app/fb2022festival/${user}.json`,
          { word: wordArray[index], date: new Date() }
        )
        .then((res) => {
          return res.data;
        });
      if (!userCtx.selectWordList.includes(wordArray[index])) {
        userCtx.setSelectWordList((prev) => [...prev, wordArray[index]]);
      }
    }
  };

  //   const lotteryMachineHandler = () => {
  //     setGotGashapon(true);
  //     lotteryPickUpWordFunction();
  //     setTimeout(() => {
  //       setComfirmResult(true);
  //       setShowComfirmLayout(true);
  //     }, 7000);
  //   };

  //   const closeResultLayoutHandler = () => {
  //     setShowComfirmLayout(false);
  //   };

  //以下測試版
  const lotteryMachineHandler = () => {
    lotteryPickUpWordFunction();
    setGotGashapon(true);
    setTimeout(() => {
      setComfirmResult(true);
      setShowComfirmLayout(true);
    }, 7000);
  };

  const closeResultLayoutHandler = () => {
    setShowComfirmLayout(false);
    setIsDailyComplete(true);
  };

  if (lotteryComplete) {
    return (
      <View style={styles.container}>
        <FontAwesome5 name="thumbs-up" size={80} color="#FDA900" />
        <View style={{ margin: 10 }}>
          <Text style={{ color: "#A67002" }}>
            您已經蒐集到「尊師慶典」四個集字！
          </Text>
          <Text style={{ color: "#A67002" }}>
            至下方「個人資訊」頁面看看您的收穫吧！
          </Text>
        </View>
      </View>
    );
  }

  //   if (!showComfirmLayout && gotGashapon && comfirmResult) {
  //     return (
  //       <View style={styles.container}>
  //         <Ionicons name="md-today" size={70} color="black" />
  //         <Text>您今日已經抽過彩蛋囉！</Text>
  //         <Text>至下方「個人資訊」頁面看看您的收穫吧！</Text>
  //       </View>
  //     );
  //   }

  if (isDailyComplete) {
    return (
      <View style={styles.container}>
        <Ionicons name="md-today" size={70} color="black" />
        <Text>您24小時內已經抽過彩蛋囉！</Text>
        <Text>請稍後重新整理頁面再試！</Text>
        {/*Remenber to change the time sitting*/}
        <Text>至下方「個人資訊」頁面看看您的收穫吧！</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <View>
        {showComfirmLayout && (
          <ComfirmLayout
            onPress={closeResultLayoutHandler}
            objectName={pickUpWord}
          />
        )}
        {!gotGashapon && !comfirmResult && (
          <>
            <Text style={styles.text}>
              親愛的{route.params.userName}講師，您好！
            </Text>
            <Button onPress={lotteryMachineHandler} title="點我抽扭蛋" />
          </>
        )}
        {gotGashapon && !comfirmResult && (
          <Image
            source={require("../assets/lotteryMachine.gif")}
            style={styles.gif}
          />
        )}
      </View>
    </View>
  );
};

export default Lottery;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EFD7AC",
  },
  gif: {
    flex: 1,
    marginLeft: 30,
    width: 300,
    height: 400,
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    margin: 10,
    fontSize: 24,
    color: "#946308",
  },
});
